import * as marietta3d from '../..';
import AutoObjCadItem from './CadItem';

/*
* Equipment
*
* new AutoEquipment( 0,1,null,"",0,0,0);
*/
export default class AutoObjEquipment extends AutoObjCadItem {
  /* constructor(index: number, cIndex: number, flr: number, p: marietta3d.AutoGen.utils.RoomPoint, item: string, rot: number, wid: number, dep: number) {
    super(index, cIndex, flr, p, item, rot, wid, dep);
  } */

  /*
    * 描画
    */
  public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D) {
    const clBlue = '#00a';
    const cl = clBlue;
    ctx.beginPath();
    ctx.fillStyle = cl;
    ctx.lineWidth = 1;
    const ip1 = sc.ConvertToCanvas(this.stroke[0]);
    ctx.moveTo(ip1.x, ip1.y);
    for (let i = 1; i < this.stroke.length; i += 1) {
      const ip2 = sc.ConvertToCanvas(this.stroke[i]);
      ctx.lineTo(ip2.x, ip2.y);
    }
    ctx.closePath();
    ctx.fill();
  }
}
